export { default } from './CardImage';
